import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { X, Loader2 } from "lucide-react";

const EMPTY = { q: "", a: "" };

export default function FAQFormModal({ initial, onClose, onSaved }) {
  const [f, setF] = useState(initial || EMPTY);
  const [loading, setLoading] = useState(false);
  const onChange = (e) => setF({ ...f, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!f.q || !f.a) { toast.error("Question & answer required"); return; }
    setLoading(true);
    try {
      if (initial) await api.patch(`/admin/faqs/${initial.id}`, { q: f.q, a: f.a });
      else await api.post("/admin/faqs", { q: f.q, a: f.a });
      toast.success(initial ? "FAQ updated" : "FAQ added");
      onSaved(); onClose();
    } catch { toast.error("Save failed"); }
    finally { setLoading(false); }
  };

  const input = "w-full px-4 py-2.5 rounded-xl border border-slate-200 text-sm focus:outline-none focus:border-[#006CE4] focus:ring-4 focus:ring-blue-100 transition";
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-testid="faq-form-modal">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl">
        <div className="flex items-center justify-between p-6 border-b border-slate-100">
          <h3 className="h3">{initial ? "Edit FAQ" : "Add FAQ"}</h3>
          <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-full"><X className="w-5 h-5" /></button>
        </div>
        <form onSubmit={submit} className="p-6 space-y-4">
          <div><label className="text-xs font-semibold muted">Question *</label><input required name="q" value={f.q} onChange={onChange} className={input} data-testid="faq-form-q" /></div>
          <div><label className="text-xs font-semibold muted">Answer *</label><textarea required name="a" value={f.a} onChange={onChange} rows="4" className={`${input} resize-none`} data-testid="faq-form-a" /></div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="btn-outline flex-1 justify-center">Cancel</button>
            <button type="submit" disabled={loading} className="btn-primary flex-1 justify-center disabled:opacity-60" data-testid="faq-form-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Save"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
